import React, { useCallback, useContext, useEffect, useMemo } from 'react';

import { useGlobalOrganization } from '../containers/SelectOrganization/useGlobalOrganization';
import { Get_Viewer_OrganizationQuery } from 'GQL/graphql.ts';

interface UserOrganizationsContextInterface {
  state: {
    organization: {
      item: Get_Viewer_OrganizationQuery['viewer']['organization'];
      loading: boolean;
    };
    selectedOrganizationId?: string;
  };
  selectOrganization: ({ organizationId }: { organizationId: string }) => void;
}

const UserOrganizationsContext = React.createContext<UserOrganizationsContextInterface>({
  state: null,
  selectOrganization: () => {},
});

const UserOrganizations = ({ children }) => {
  const { viewerOrganization, isLoading, selectGlobalOrganization } = useGlobalOrganization();

  useEffect(() => {
    window.PALYX_DEBUG.getUserOrgaInfo = () => viewerOrganization;
  }, [viewerOrganization]);

  const handleSelectOrganization = useCallback(
    ({ organizationId }: { organizationId: string }) => {
      selectGlobalOrganization(organizationId);
    },
    [selectGlobalOrganization]
  );

  const providerValue: UserOrganizationsContextInterface = useMemo(() => {
    const state = {
      organization: {
        //TODO: Getting to this value is a bit convoluted (state.organization.item.organization), consider simplifying
        item: viewerOrganization,
        loading: isLoading,
      },
      selectedOrganizationId: viewerOrganization?.organization?._id,
    };

    return {
      state,
      selectOrganization: handleSelectOrganization,
    };
  }, [viewerOrganization, isLoading, handleSelectOrganization]);

  return (
    <UserOrganizationsContext.Provider value={providerValue}>
      {children}
    </UserOrganizationsContext.Provider>
  );
};

export const useUserOrganizationsContext = () => useContext(UserOrganizationsContext);

const withUserOrganizations = Component => props => {
  const data = useUserOrganizationsContext();
  return <Component {...props} userOrganizations={data} />;
};

export {
  UserOrganizationsContext,
  UserOrganizations as UserOrganizationsProvider,
  withUserOrganizations,
};
